import React from 'react';
import { useTranslation } from 'react-i18next';
import WorkImg from "../assets/images/work/hero-work.png";
import { workImgs } from './images';
import { SectionProps } from './Landing';

const Work = ({ handleImgClick }: SectionProps) => {
    const { t } = useTranslation();

    return (
        <section className='section' id="work">
            <h2 className="section__title">{t('workTitle')}</h2>
            <div className="section__title-underline"></div>
            <div className='section__body'>
                <div className="section__body-wrapper">
                    <div className="section__img-wrapper">
                        <img className="section__img" src={WorkImg} alt="hand holding a shiny apple" />
                    </div>
                    <p className="section__text">{t('workIntro')}</p>
                </div>
                <div className="section__body-wrapper">
                    <ul className="section__gallery">
                        {workImgs.map((img, i) => (
                            <li key={i} className='section__gallery-item' onClick={() => handleImgClick(img)}>
                                <img className='section__gallery-item-img' src={img.img} alt={img.description} />
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </section>
    )
};

export default Work;